import { render, staticRenderFns } from "./CompletedTaskApproval.vue?vue&type=template&id=08e9172b"
import script from "./CompletedTaskApproval.vue?vue&type=script&lang=js"
export * from "./CompletedTaskApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports